import React from 'react';
import PropTypes from 'prop-types';
import { compose, showProgress } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import Modal from '../../../commonComponents/modal/Modal';

function QuizResultModal({ t, onClose, results }) {
  const { totalAnswers, correctAnswers, incorrectAnswers, status, quizApproval } = results;
  const approved = status === 'passed';
  return (
    <Modal onClose={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-body">
            <div className="container-fluid">
              <h3 className="congratulations">
                {approved ? t('academy.course.quizModal.approved') : t('academy.course.quizModal.failed')}
              </h3>
              <div className="quiz-results">
                <div className="row quiz-results-container">
                  <span className="col-lg-8 quiz-results-container-label">{t('academy.course.quizModal.total_answers')}</span>
                  <span className="col-lg-4 quiz-results-container-value">{totalAnswers}</span>
                </div>
                <div className="row quiz-results-container">
                <span className="col-lg-8 quiz-results-container-label">{t('academy.course.quizModal.correct_answers')}</span>
                  <span className="col-lg-4 quiz-results-container-value quiz-correct">{correctAnswers}</span>
                </div>
                <div className="row quiz-results-container">
                <span className="col-lg-8 quiz-results-container-label">{t('academy.course.quizModal.incorrect_answers')}</span>
                  <span className="col-lg-4 quiz-results-container-value quiz-incorrect">{incorrectAnswers}</span>
                </div>
                <div className="row quiz-results-container">
                <span className="col-lg-8 quiz-results-container-label">{t('academy.course.quizModal.quizPercentage')}</span>
                  <span
                    className={`col-lg-4 quiz-results-container-value ${approved ? 'quiz-correct' : 'quiz-incorrect'}`}
                  >
                    {`${showProgress(quizApproval)}%`}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-dynamic quiz-results-btn" onClick={() => onClose(approved)}>
              {approved ? t('academy.course.quizModal.continue') : t('academy.course.quizModal.restart')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

QuizResultModal.propTypes = {
  t: PropTypes.func.isRequired,
  results: PropTypes.shape({
    totalAnswers: PropTypes.number,
    correctAnswers: PropTypes.number,
    status: PropTypes.string,
    quizApproval: PropTypes.number,
    incorrectAnswers: PropTypes.number,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

QuizResultModal.defaultProps = {
};

export default compose(withCSRF, translate)(QuizResultModal);
